import { Clock } from "lucide-react";

import { cn } from "../../lib/utils";
import { resumoDoEstado } from "../../helpers/horarioDeAtendimento";

// "Fora do expediente" em uma linha, no mesmo formato nas duas telas.
//
// O estado vem PRONTO do backend (`GET /horarios` → `estadoDoHorario`): este
// componente só escolhe a cor e a frase. É informativo e nunca bloqueia nada —
// existe para explicar por que o cliente recebeu o aviso automático, não para
// impedir o atendente de responder.
//
// `title` em vez do Tooltip do Radix: ele entra no cabeçalho do atendimento e
// na lista de conexões, e o provider do Radix nem sempre está por perto —
// faltando, o componente derruba a tela em runtime (mesma decisão do
// BotaoDeVoz).
const ChipDeExpediente = ({ estado, mostrarAberto = false, className }) => {
  // Empresa que atende a qualquer hora não tem expediente para mostrar: a
  // linha seria ruído em toda conversa.
  if (!estado || estado.motivo === "sem_horario") return null;

  if (estado.aberto && !mostrarAberto) return null;

  const texto = resumoDoEstado(estado);

  if (!texto) return null;

  return (
    <span
      title={
        estado.aberto
          ? "Horário de atendimento desta conexão"
          : `${texto} (horário da empresa)`
      }
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium",
        estado.aberto
          ? "bg-muted text-muted-foreground"
          // amber-600 sobre o fundo claro dá ~2,95:1 em texto de 11px, abaixo
          // do mínimo de 4,5:1 — no escuro o problema não aparece, que é por
          // onde passou.
          : "bg-amber-500/10 text-amber-700 dark:text-amber-400",
        className,
      )}
    >
      <Clock className="h-3 w-3" aria-hidden />
      {texto}
    </span>
  );
};

export default ChipDeExpediente;
